module.exports = __webpack_public_path__ + "img/peopleDel.4b55bea4.svg";